<template>
  <div class="details-box">
    <div class="details-title">{{currentData.title}}</div>
    <div class="details-info">
      <span>发布人：{{currentData.publishByName}}</span>
      <span>{{currentData.publishDate}}</span>
      <span>阅读量：{{currentData.readingQuantity}}</span>
    </div>
    <div class="details-content">
      <p v-html="currentData.content">{{currentData.content}}</p>
      <!--      <video v-if="false" src=""></video>-->
    </div>
    <div @click="flie(currentData)" class="flie" v-if="currentData.fileName">
      <span>
        <img style="width:20px;height:27px;" src="/static/img/flies.jpg" alt />
      </span>
      <span>文件名 : {{currentData.fileName}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  props: {
    currentData: {
      type: Object,
      default() {
        return {
          title: "肖义：积极探索绿色崛起的“安化模式”",
          publishByName: "张家",
          time: "2018-10-30",
          readCount: "1235",
          content:
            "8月9日上午，我县召开《贫困地区绿色崛起模式研究》初步成功交流会。县委副书记、县长肖义，县人大常委会副主任肖伟群，老领导蒋跃登出席交流会。\n" +
            "        会上，国务院发展研究中心资源与环境政策研究所副所长李佐军详细汇报了《贫困地区绿色崛起模式研究——探索绿色发展、精准脱贫与乡村振兴有机结合之路》课题研究初步成果，并听取了我县县委、县政府领导及相关部门负责人的意见。 5月23日-26日，课题组在我县进行了集体实地调研，并于8月4日形成了《贫困地区绿色崛起模式研究征求意见稿》。\n" +
            "        肖义对课题初步研究成果表示充分肯定，他表示，安化县要朝成为绿色崛起示范区、乡村振兴探索区的方向奋勇前进，坚定发展目标，积极探索绿色崛起的“安化模式”。\n" +
            "        据了解，8月10日，调研组将进一步实地考察调研安化黑茶产业、绿色发展、乡村振兴、精准扶贫实施情况。"

          // nextArticle: '安化2019年8月12日每日天气与农事',
        };
      }
    }
  },
  data() {
    return {
      listData: []
    };
  },
  methods: {
    flie(file) {
      console.log(file)
   
        let url = 'https://nongji-img.ahnydsj.com/nongji-api/zs/common/downloadFile' + '?userId=1' 
                   + '&token=1' + '&fileUrl=' + file.fileUrl
                  + '&fileName=' + file.fileName
        window.open(url, '_self');
     
      
    }
  }
};
</script>

<style lang="less">
.details-box {
  font-family: PingFangSC-Regular;
  width: 1200px;
  padding: 0 36px;
  margin: 20px auto 0;
  background: #ffffff;
  .details-title {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    font-size: 26px;
    color: #333333;
  }
  .details-info {
    height: 30px;
    width: 100%;
    background: #f6f6f6;
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
    span {
      font-size: 14px;
      color: #999999;
      padding: 0 30px;
    }
  }
  .flie {
    color: #149508;
    padding-bottom: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .details-content {
    width: 1150px;
    padding-bottom: 45px;
    p {
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Details.vue